import React from "react";
import {Icon} from "@blueprintjs/core";

const TextInput = (props) => {
    const {
        value,
        setValue,
        type = "text",
        style = {},
        placeholder = "",
        label = "",
        icon = "",
        onKeyDown = () => {},
        validation = false,
        isValid = true,
        errorMessage = "",
        fileValue = false
    } = props;

    return (
        <div style={{
            position: "relative",
            ...style
        }}>
            {!!label && <div style={{
                color: "black",
                fontWeight: "bold",
                fontSize: 12,
                marginBottom: 5
            }}>{label}</div>}
            <input
                type={type}
                style={{
                    transition: "all 0.4s",
                    ...isValid ? null : {borderColor: "red"},
                    ...icon ? {paddingLeft: "40px"} : null
                }}
                value={value}
                onChange={fileValue ? (e) => setValue(e.target.files) : (e) => setValue(e.target.value)}
                placeholder={placeholder}
                onKeyDown={onKeyDown}
            />
            {icon && (
                <div style={label ? iconLabelStyle : iconStyle}>
                    <Icon icon={icon} iconSize={20} />
                </div>
            )}
            {validation && (
                <div style={{
                    color: "red",
                    height: 18,
                    fontSize: 12
                }}>
                    {!isValid && errorMessage}
                </div>
            )}
        </div>
    );
};

export default TextInput;

const iconStyle = {
    cursor: "pointer",
    position: "absolute",
    top: "11px",
    left: "12px",
    color: "rgb(97, 97, 97)"
}

const iconLabelStyle = {
    cursor: "pointer",
    position: "absolute",
    top: "31px",
    left: "12px",
    color: "rgb(97, 97, 97)"
}